import React from "react"
import {makeStyles} from "@mui/styles"

import InputCardNumber from "./InputCardNumber"
import ConfirmCardNumber from "./ConfirmCardNumber"
import InputFlawNumber from "./InputFlawNumber"
import ActionHeader from "./ActionHeader"
import InputCardNumberWithRetail from "./InputCardNumberWithRetail"
import { Box, Typography } from "@mui/material"

const baseAction = {
	textAlign: "center",
	alignSelf: "center",
	width: "100%",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
}

const sx = {
	availableProductCard: {
		padding: "16px",
		alignItems: "center",
		gap: "4px",
		display: "flex",
		flexDirection: "column",
		borderRadius: "8px",
		border: "1px solid #DBDBDB",
		background: "#FFF",
		flex: 1
	},
	availableProductValue: {
		color: "#000",
		textAlign: "center",
		fontSize: 27,
		fontStyle: "normal",
		fontWeight: 700,
		lineHeight: "normal",
	},
	availableProductLabel: {
		color: "#000",
		textAlign: "center",
		fontSize: 27,
		fontStyle: "normal",
		fontWeight: 400,
		lineHeight: "normal",
	}
}

const useStyles = makeStyles(() => ({
	root: {
		...baseAction,
		"& form": {
			...baseAction
		}
	},
		noSelection: {
				maxWidth: 438,
				fontWeight: 300,
				fontSize: 37,
				lineHeight: "43px",
				marginTop: 120
		}
}))

const ActionContent = (props) => {
		const { 
			step,
			selectedCard,
			openModal,
			textHeader,
			handleClose,
			handleValidate,
			onSubmitWithRetail,
			valuesByStep,
			onChangeInputWithRetail,
			isTablet,
			setValue,
			lostActionInfos,
			isInventory,
			noDisplay,
			hub,
			availableVolume = 0
		} = props
	const classes = useStyles()

		return (
				<>
						{/* header */}
						{ selectedCard.length !== 0 &&
								<ActionHeader text={textHeader} handleClose={handleClose}/>
						}

						<div className={classes.root}>
								{/* none selected display */}
								{ step === 0 && selectedCard.length === 0  &&
										<div className={classes.noSelection}>
											{!isInventory &&
												<>
													Choisissez un produit à réceptionner
												</>
											}
											{isInventory &&
												<>
													Choisissez un produit
												</>
											}
										</div>
								}
		
								{!noDisplay && selectedCard.length !== 0 && (
									<Box sx={hub?.activeRetailOffer ? { paddingTop: "32px" } : {}}>
										{hub?.activeRetailOffer && (
											<Box sx={sx.availableProductCard}>
												<Typography sx={sx.availableProductValue}>
													{availableVolume}
												</Typography>
												<Typography sx={sx.availableProductLabel}>
													Produits disponibles
												</Typography>
											</Box>	
										)}

										{/* one selected display */}
										{step === 1
											? hub?.activeRetailOffer
												? (
													<InputCardNumberWithRetail
														selectedCard={selectedCard} 
														onSubmit={onSubmitWithRetail}
														isTablet={isTablet}
														initialValues={valuesByStep[1]}
														onChangeInput={onChangeInputWithRetail}
														availableVolume={availableVolume}
													/>
												)
												: <InputCardNumber 
													selectedCard={selectedCard} 
													openModal={openModal}
													handleValidate={handleValidate}
													isTablet={isTablet}
													setValue={setValue}
													isInventory={isInventory}
													availableVolume={availableVolume}
												/>
											: null
										}

										{/* Confirm input */}
										{step === 2
												? hub?.activeRetailOffer
													? (
														<InputCardNumberWithRetail
															selectedCard={selectedCard} 
															onSubmit={onSubmitWithRetail}
															isTablet={isTablet}
															initialValues={valuesByStep[2]}
															onChangeInput={onChangeInputWithRetail}
															availableVolume={availableVolume}
															isConfirmation
														/>
													)
													: <ConfirmCardNumber 
														selectedCard={selectedCard} 
														openModal={openModal} 
														handleValidate={handleValidate} 
														isTablet={isTablet} 
														setValue={setValue}
														isInventory={isInventory}
													/>
												: null
										}

										{/* set flaw or break meal */}
										{ step === 3 &&
												<InputFlawNumber
													openModal={openModal}
													handleValidate={handleValidate} 
													isTablet={isTablet}
													setValue={setValue}
													lostActionInfos={lostActionInfos}
												/>
										}
									</Box>
								)}

						</div>
				</>
		)
}

export default ActionContent